import { FC, SVGAttributes } from "react";

const KlarnaIconBackground: FC<SVGAttributes<SVGSVGElement>> = ({
  width = 32,
  height = 24,
  color = "#0A0B09",
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 2048 1188"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>Klarna</title>
    <rect
      x="0"
      y="0"
      width="2048"
      height="1188"
      rx="200"
      ry="200"
      fill="white"
      stroke="#EEEEEE"
      strokeWidth="50"
    />
    <path
      transform="translate(488,280)"
      d="m0 0h1073l44 3 27 4 21 5 16 6 19 10 16 12 13 12 7 7 13 17 9 16 5 11 6 18 5 26 3 27 2 39 1 62v74l-1 64-2 39-3 26-5 25-7 21-8 16-9 14-9 11-11 12-14 12-15 10-16 8-21 7-24 5-36 4-46 2h-1039l-44-2-36-4-22-5-16-5-15-7-14-8-16-13-18-18-12-16-9-16-8-21-5-21-4-28-2-24-1-20-1-48v-122l1-39 2-34 3-27 5-25 8-24 9-17 10-14 12-14 8-8 11-9 16-11 16-8 18-6 22-5 21-3 27-2z"
      fill="#FEB0CF"
    />
    <path
      transform="translate(466,458)"
      d="m0 0h59l1 1v132l10-6 17-12 13-11 10-9 8-9 8-10 11-18 8-18 5-18 3-21 1-1h56v12l-2 18-6 25-8 20-10 18-9 12-9 11-13 13-11 9-3 3 4 6 9 12 16 21 15 20 14 18 12 16 13 17 10 13 1 4h-71l-5-5-15-20-16-21-12-16-16-21-14-19-14-18-8-11-1-1-1 118-1 14h-59z"
      fill="#0B061E"
    />
    <path
      transform="translate(1456,536)"
      d="m0 0h19l14 3 12 5 11 7 9 9 7 10 4 6-4-19-2-11 1-5h54l1 1v182l-2 2h-50l-4-1 1-11 4-18 2-6-3 3-7 11-6 7-10 8-14 7-10 3-7 1h-23l-14-3-15-6-11-7-12-10-11-15-7-14-5-16-2-11v-30l4-18 5-13 6-11 10-13 11-10 15-9 13-5z"
      fill="#0B061E"
    />
    <path
      transform="translate(878,536)"
      d="m0 0h21l16 4 16 8 10 9 7 8 7 11 2 1-4-10-3-17v-9h54l1 1v176l-1 7-1 1h-50l-3-1v-9l4-20v-4l-8 12-9 10-14 9-16 6-7 1h-24l-14-3-13-5-13-8-10-9-7-7-11-18-7-21-3-24 1-14 3-17 5-15 9-16 12-14 13-10 16-8 15-4z"
      fill="#0B061E"
    />
    <path
      transform="translate(1267,536)"
      d="m0 0h22l18 4 11 5 10 6 11 10 7 10 5 10 4 14 1 14v95l-1 21-1 1h-54l-1-1-1-109-4-13-6-8-7-5-9-3h-18l-13 5-8 7-7 14-1 6-1 106-1 1h-56v-184l1-1h54v9l-3 17-3 10h2l2-6 8-12 8-9 10-7 8-4z"
      fill="#0B061E"
    />
    <path
      transform="translate(719,458)"
      d="m0 0h56v266l-2 2h-54z"
      fill="#0B061E"
    />
    <path
      transform="translate(1129,539)"
      d="m0 0 14 1 1 1v55h-27l-12 6-7 8-4 8-2 8-1 32-1 68h-56v-185h55l-1 14-3 14-3 8 3-3 8-15 7-8 14-9 7-2z"
      fill="#0B061E"
    />
    <path
      transform="translate(505,467)"
      d="m0 0h7l3 3 2 12 1 22-1 68 1 23 1 4-1 4-1 3v22l-1 40 2 1v2h-2l2 4h-2l1 8-1 4h2l-1 2v8l-1 2v16l-3 3-14-2-20-1h-2l-2 2-2-4h2l-2-3-2-52v-157l1-23 5-8 4-1 15 1 5 1 1-3z"
      fill="#0B061E"
    />
    <path
      transform="translate(466,458)"
      d="m0 0h59l1 1v132l10-6 17-12 13-11 10-9 8-9 8-10 11-18 8-18 5-18 3-21 1-1h56v12l-2 18-6 25-8 20-10 18-9 12-9 11-13 13-11 9-3 3 4 6 9 12 16 21 15 20 14 18 12 16 13 17 10 13 1 4h-71l-5-5-15-20-16-21-12-16-16-21-14-19-14-18-8-11-1-1-1 118-1 14h-59zm190 8-7 2h-17l-5 2v3l-2 1-4 14-4 12v4h-2l-4 9-6 11-6 9-8 11v2h-2l-9 11-5 4v2l-5 2-14 13-15 10-4 2-1 6 5 7h2l2 4 7 10 1 2h2l1 4 7 9 4 6 3 4h2l2 6 8 9 2 4h2l2 4 3 5h2l1 4h2l2 5 3 4h2l2 5 9 11 7 9 5 7 5 4 3 1h26l17-2 1-1v-8l-2-1-3-6h-2l-2-5-5-7h-2l-2-5-7-10-1-2h-2l-2-5-5-5-1-3h-2l-2-5-6-8h-2l-2-4-5-8h-2l-2-4-10-14-4-5-4-9v-5l2-2 3-6 2-1v-2l4-2 9-8 3-4v-2l3-1 4-5 5-5 4-6v-2h2l3-6 5-8 2-5v-4l2-1 3-7 4-16 3-8 2-19v-9l-3-3zm-151 1-4 2v2l-11-1-10-1-5 3-3 6-1 24v156l2 52 2 3-2 1 3 3 2-3 1 1 20 1 14 2 3-3v-17l1-2v-7l1-2h-2l1-5-1-7h2l-2-4h2v-2l-2-1 1-48v-16l1-5 1-3-1-1-1-26 1-65-1-22-2-12-4-3z"
      fill="#050314"
    />
    <path
      transform="translate(1267,536)"
      d="m0 0h22l18 4 11 5 10 6 11 10 7 10 5 10 4 14 1 14v95l-1 21-1 1h-54l-1-1-1-109-4-13-6-8-7-5-9-3h-18l-13 5-8 7-7 14-1 6-1 106-1 1h-56v-184l1-1h54v9l-3 17-1 3-4 2-4-1 1-13-1-3 1-6-4-1-4 2-8 1-4 1h-10l-5 1-1 8-1 53 1 9v20 3 13 4 16l1 5 1 16-1 5 1 7v1l15 1 5-1 7 2h8l2-3-1-8 1-3-1-1v-50l1-7 1-4 1-17 4-17 2-4h2l1-4 5-5 8-7 11-4 8-1h10l10 2 12 6 7 5 6 10 2 4 1 17-1 13 1 8v26l1 25v14l2-4 1 7 2 1h24l10 1v-13l1-26 1-21v-57l-2-7-3-7-1-7-8-10-6-7-7-6-15-7-11-3-9-1-14 1-13 3-14 7-8 7h-2l-1 5-8 6-4 2 2-8 10-13 11-9 10-5z"
      fill="#050314"
    />
    <path
      transform="translate(1473,585)"
      d="m0 0h11l8 2 10 4 10 8 8 11 4 10 2 8v10l-3 12-6 12-7 8-11 7-11 4-13 1-13-3-12-7-8-8-6-10-3-7-1-6v-15l4-13 5-9 7-8 11-7 8-3z"
      fill="#FEB0CF"
    />
    <path
      transform="translate(895,585)"
      d="m0 0h11l10 2 12 6 10 9 6 10 4 12v20l-5 13-8 11-11 8-9 4-12 2-11-1-13-5-9-7-8-9-5-11-2-7v-16l4-13 5-9 11-11 12-6z"
      fill="#FEB0CF"
    />
    <path
      transform="translate(1129,539)"
      d="m0 0 14 1 1 1v55h-27l-12 6-7 8-4 8-2 8-1 32-1 68h-56v-185h55l-1 14h-2l-1 9-2 7-5-1-1-1 1-16-1-5-8 1v1l-8 2h-13l-5 2-2 9-1 8v56l1 51 1 28 2 4 6 3 14 1 8 2h7l1-1 1-27v-36l1-10 1-4v-15h2l2-9 1-4h2l1-4 3-3h2l1-5 7-6 8-2v-2l8-2h9 2l4-3v-21l-1-9-1-5-11 2-12 6h-2v2l-5 4h-2l-2 4-5 4-5 1 1-7 8-11 11-8 8-4z"
      fill="#050314"
    />
    <path
      transform="translate(467,459)"
      d="m0 0h57l1 16v124l-1 125-1 1h-56zm38 8-4 2v2l-11-1-10-1-5 3-3 6-1 24v156l2 52 2 3-2 1 3 3 2-3 1 1 20 1 14 2 3-3v-17l1-2v-7l1-2h-2l1-5-1-7h2l-2-4h2v-2l-2-1 1-48v-16l1-5 1-3-1-1-1-26 1-65-1-22-2-12-4-3z"
      fill="#040313"
    />
    <path
      transform="translate(721,459)"
      d="m0 0h52l1 1v259l-1 5h-52v-32l1-21 3 1 1 8 1 16 1 3-1 1v6l2 1-1 4v-2l-2 1v2h2l2 4 16-1 16 2 2-1 1-8v-15l1-25v-163l-1-29-2-8h-8l-8 2h-18l-1 6-3 9v48l-1 7v11l-2 4-1-44-1-51z"
      fill="#040313"
    />
    <path
      transform="translate(878,536)"
      d="m0 0h21l16 4 16 8 10 9 7 8 5 8 1 4 4 2-2 1v2l-5-2-5-3v-2h-2v-2l-3-1-4-5-6-8-7-6-13-7-9-3h-13l-4 1h-7l-17 4-12 5-11 7-5 4h-2v2h-2l-2 5-6 9h-2l-1 5-7 14-5 19v22l2 18 4 10 3 9 6 12 6 8v2l4 2 11 9 12 7 17 5 5 1h22l2 1 1-2 6-1 7-2v-2l6-1 11-8h2l1-3h2l1-3h2l2-4 4-3 3 1-1 7-10 11-14 9-16 6-7 1h-24l-14-3-13-5-13-8-10-9-7-7-11-18-7-21-3-24 1-14 3-17 5-15 9-16 12-14 13-10 16-8 15-4z"
      fill="#050314"
    />
    <path
      transform="translate(950,541)"
      d="m0 0h54l1 1v176l-1 7-1 1h-50l-3-1v-9l4-20 1-3h2v-3l3-1 3 5-1 10-1 11 2 2 9-1h21l1-3 1-15 1-5-1-15v-63l1-11-1-6 1-10-1-32-2-5-1-1h-7l-6 2-16 1-2 2-1 6-1-4h-2v4l-4 1v-5h-2l-1-7z"
      fill="#050315"
    />
    <path
      transform="translate(1456,536)"
      d="m0 0h19l14 3 12 5 11 7 9 9 7 10 3 7 3 3-2 1-7-3-3-2v-2l-4-2-14-17-12-8-12-3-2-1h-13l-9 1-17 4-19 8-10 8-3 1-2 4-4 4-3 6-4 6-2 4-5 12-1 4-2 7-1 12 1 25 2 9 1 5-1 2 2 1 3 9 5 10 5 7 3 5v2l3 1v2l5 2v2l5 2 8 6 14 6 12 3h26l5-1 1-2v2l12-5 10-6 5-4h2v-2l5-4 4-5 4 3-2 5-6 7-10 8-14 7-10 3-7 1h-23l-14-3-15-6-11-7-12-10-11-15-7-14-5-16-2-11v-30l4-18 5-13 6-11 10-13 11-10 15-9 13-5z"
      fill="#050314"
    />
    <path
      transform="translate(1527,541)"
      d="m0 0h54l1 1v182l-2 2h-50l-4-1 1-11 4-18 1-3h2v-4h2v2h2v11l-3 11 1 5 1 1h9l1-2h22l3-2 1-5h2v-6l1-2v-16l1-11h-2v-14l-1-3 1-4-1-5v-80l-1-7-2-6 1-6h-8l-4 4h-17l-4 2-3 9v12h-2v-3h-2l-5-22-1-10z"
      fill="#050315"
    />
    <path
      transform="translate(899,579)"
      d="m0 0 11 1 13 4 8 5 4 2v2l4 1v2l3 1 7 9 5 15 2 14v1l-2 1v7l-5 14-6 9-5 6-5 2v2l-9 6-16 5h-7l-6-2-9-1-11-5-9-6-6-5-6-9-1-5-3-1-3-12-1-13 2-10 4-10 2-3 4-5 3-5h2l2-4 2-3h3v-2l8-4 7-1 1-1zm-4 6-13 4-9 6-10 10-6 13-2 8v16l4 12 6 10 8 8 10 6 9 3 11 1 12-2 14-7 8-7 7-11 4-11v-20l-4-12-6-10-7-7-12-7-6-2-7-1z"
      fill="#050314"
    />
    <path
      transform="translate(1477,579)"
      d="m0 0 14 2 10 4 9 5 5 4 3 3v2l4 2 6 10 3 6 2 19-2 12-6 12-7 9-4 4h-2v2l-6 4-11 5h-3l-1 2-9 2h-5l-5-3-11-1-16-8-7-6-5-7-1-3-4-4-3-10v-23l3-12 3-5 6-8 6-7h2v-2l8-5 9-2zm-4 6-12 3-10 6-8 7-6 9-4 11-1 5v15l2 8 6 12 9 10 11 7 9 3 12 1 14-3 11-6 8-7 7-11 4-12 1-5v-10l-5-16-7-11-9-8-10-5-5-2-6-1z"
      fill="#050314"
    />
    <path
      transform="translate(466,458)"
      d="m0 0h59l1 1v132l4-1-1 3v3l-2-2-1 118-1 14h-59zm1 1v266h56l1-1 1-149v-103l-1-13z"
      fill="#0C071F"
    />
    <path
      transform="translate(697,722)"
      d="m0 0 2 4h-71l-2-1 1-2 3 1h67z"
      fill="#0C071F"
    />
    <path
      transform="translate(834,554)"
      d="m0 0 2 1-16 16v-3l9-10z"
      fill="#09051A"
    />
  </svg>
);

export default KlarnaIconBackground;
